import { Link } from "gatsby";
import * as React from "react";

const Experience = ({
  title,
  btnText,
  btnLink,
  img,
  name,
  designation,
  pagetitle,
  description,
}) => {
  return (
  <>
    {
      (

    <div className="experience">
      <div className="content">
        <div className="information flex-1">
          <div className="inner-content">
            <h3>{title}</h3>
            <Link to={btnLink}>
              <button className="btndefault greenbtn">{btnText}</button>
            </Link>
          </div>
        </div>
        <div className="slide-block">
          <div className="user-detail">
            <img src={img} alt="Experience" />
            <div className="detail">
              <div className="blocker">
                <h4>{name}</h4>
                <h5>{designation}</h5>
              </div>
              {pagetitle && <h6>{pagetitle}</h6>}
            </div>
          </div>
          <div className="description">
            {/* <img src={doter} alt="Dots" /> */}
            <div className="quote-left">“</div>
            <p>{description}</p>
          </div>
        </div>
      </div>
    </div>
  )
    }
    </>
  )
}

export default Experience
